import axiosInstanceApiGateway from 'config/apiServiceApiGateway'
import { CrossDockTaskInterface } from '../@types/XDock'

export type GetXdockListResponseType = {
  data: {
    id: number
    xdock_task_number: string
    purchase_order_id: number
    purchase_order_number: string
    location_id: number
    location_name: string
    product_id: number
    product_name: string
    product_sku_number: string
    product_uom: string
    category_id: number
    category_name: string
    staff_id: number
    staff_name: string
    total_qty: number
    inbound_date: number
    destination_count: number
    status: string
  }[]
  pagination: {
    sort: string
    direction: string
    page_size: number
    page_index: number
    number_of_elements: number
  }
}

export type GetXdockListParamsType = {
  page_size: number
  page_index: number
  search_product?: string
  search_po_number?: string
  staff_id?: number
  status: string
}

export type GetStaffSorterByLocationResponseType = {
  id: number
  fullName: string
}

export type GetStaffSorterByLocationKongResponseType = {
  staff_id: number
  staff_full_name: string
}

export const getXdockList = (params: Partial<GetXdockListParamsType>) =>
  axiosInstanceApiGateway.Get<CrossDockTaskInterface[]>({
    url: '/wims/internal/v1/xdock-tasks',
    params,
  })

export const assignXdockTask = (id: number, data: { staff_id: number }) =>
  axiosInstanceApiGateway.Post<{ message: string }, true>({
    url: `/wms/internal/v1/xdock-tasks/${id}/assign`,
    data,
  })

export const getStaffSorterByLocation = (locationId: number) =>
  axiosInstanceApiGateway.Post<{ data: GetStaffSorterByLocationKongResponseType[] }, true>({
    url: `/staff-management/internal/v1/staff/get-by-role`,
    data: {
      role_name: 'AUTH_SORTER',
      location_id: locationId,
    },
  })
